"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusPremiumStatusKindEnum = exports.CustomerStatusPremiumStatusToJSON = exports.CustomerStatusPremiumStatusFromJSONTyped = exports.CustomerStatusPremiumStatusFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CustomerStatusPremiumStatusFromJSON(json) {
    return CustomerStatusPremiumStatusFromJSONTyped(json, false);
}
exports.CustomerStatusPremiumStatusFromJSON = CustomerStatusPremiumStatusFromJSON;
function CustomerStatusPremiumStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kind': json['kind'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : json['endDate'],
        'renewalDate': !(0, runtime_1.exists)(json, 'renewalDate') ? undefined : json['renewalDate'],
        'lastUpdate': !(0, runtime_1.exists)(json, 'lastUpdate') ? undefined : json['lastUpdate'],
        'cancellable': !(0, runtime_1.exists)(json, 'cancellable') ? undefined : json['cancellable'],
        'orderCount': !(0, runtime_1.exists)(json, 'orderCount') ? undefined : json['orderCount'],
        'orders': !(0, runtime_1.exists)(json, 'orders') ? undefined : (0, _1.AmountFromJSON)(json['orders']),
        'savings': !(0, runtime_1.exists)(json, 'savings') ? undefined : (0, _1.AmountFromJSON)(json['savings']),
        'salesTarget': !(0, runtime_1.exists)(json, 'salesTarget') ? undefined : (0, _1.AmountFromJSON)(json['salesTarget']),
    };
}
exports.CustomerStatusPremiumStatusFromJSONTyped = CustomerStatusPremiumStatusFromJSONTyped;
function CustomerStatusPremiumStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'kind': value.kind,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'renewalDate': value.renewalDate,
        'lastUpdate': value.lastUpdate,
        'cancellable': value.cancellable,
        'orderCount': value.orderCount,
        'orders': (0, _1.AmountToJSON)(value.orders),
        'savings': (0, _1.AmountToJSON)(value.savings),
        'salesTarget': (0, _1.AmountToJSON)(value.salesTarget),
    };
}
exports.CustomerStatusPremiumStatusToJSON = CustomerStatusPremiumStatusToJSON;
/**
* @export
* @enum {string}
*/
var CustomerStatusPremiumStatusKindEnum;
(function (CustomerStatusPremiumStatusKindEnum) {
    CustomerStatusPremiumStatusKindEnum["Dummy"] = "dummy";
    CustomerStatusPremiumStatusKindEnum["Subscription"] = "subscription";
    CustomerStatusPremiumStatusKindEnum["Fixedterm"] = "fixedterm";
    CustomerStatusPremiumStatusKindEnum["Salestarget"] = "salestarget";
    CustomerStatusPremiumStatusKindEnum["Loyalcustomer"] = "loyalcustomer";
})(CustomerStatusPremiumStatusKindEnum = exports.CustomerStatusPremiumStatusKindEnum || (exports.CustomerStatusPremiumStatusKindEnum = {}));
//# sourceMappingURL=CustomerStatusPremiumStatus.js.map